enum MAIN_PAGES_BACKGROUNDS {
    WHITE = 'WHITE',
    GHOST_WHITE = 'GHOST_WHITE',
    BLUE = 'BLUE',
}

export { MAIN_PAGES_BACKGROUNDS };
